import { render } from "./UkView.vue?vue&type=template&id=3b3e5d14"
import script from "./UkView.vue?vue&type=script&lang=js"
export * from "./UkView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__